// extracted by mini-css-extract-plugin
export default {"disclaimer":"disclaimer__Iq0QNVL_YKJuTb1OSd13"};